
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalConstants } from '../common/global-constants';
import { Observable } from 'rxjs';
import { BOToothStateDetail } from '../models/odo/BOToothStateDetail.model';

export interface ToothStateDetailGroup {
  key: number;
  items: BOToothStateDetail[];
}

@Injectable({
  providedIn: 'root'
})


export class ToothStateDetailService
{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/toothStateDetail/';

    constructor(private http:HttpClient){}

  //#region First
    saveToothStateDetail(toothStateDetail:BOToothStateDetail):Observable<BOToothStateDetail>{
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(toothStateDetail);
      return this.http.post<BOToothStateDetail>(this.myAppUrl + this.myApiUrl+'saveToothStateDetail',body,httpOptions);
    }

    saveToothStateDetailList(toothStateDetail:BOToothStateDetail[]):Observable<number>{
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(toothStateDetail);
      return this.http.post<number>(this.myAppUrl + this.myApiUrl+'saveToothStateDetailList',body,httpOptions);
    }

    CreateOrUpdateToothStateDetailDataList(sdList:BOToothStateDetail[]):Observable<BOToothStateDetail[]>
    {
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(sdList);
        return this.http.post<BOToothStateDetail[]>(this.myAppUrl + this.myApiUrl + 'CreateOrUpdateToothStateDetailDataList',body,httpOptions);
    }

    getToothStateDetailsByToothIdPersonIdOdontogramaId(toothTypeId:number, personId:number, odontogramaId:number):Observable<BOToothStateDetail[]>{
          //const body= JSON.stringify(datesFilter);
      return this.http.get<BOToothStateDetail[]>(this.myAppUrl + this.myApiUrl + 'getToothStateDetailsByToothIdPersonIdOdontogramaId/'+toothTypeId+'/'+personId +'/'+ odontogramaId);
    }

    getToothStateDetailsByClinicHistoryId(clinicHistoryId:number):Observable<BOToothStateDetail[]>{
            //const body= JSON.stringify(datesFilter);
        return this.http.get<BOToothStateDetail[]>(this.myAppUrl + this.myApiUrl + 'getToothStateDetailsByClinicHistoryId/'+clinicHistoryId);
    }

    getToothStateDetailsByClinicHistoryIdPersonId(clinicHistoryId:number, personId:number):Observable<BOToothStateDetail[]>{
          //const body= JSON.stringify(datesFilter);
      return this.http.get<BOToothStateDetail[]>(this.myAppUrl + this.myApiUrl + 'getToothStateDetailsByClinicHistoryIdPersonId/'+clinicHistoryId+'/'+personId);
    }

    getStateDetailsByChAgroupedByToothId(clinicHistoryId:number):Observable<BOToothStateDetail[][]>{
          //const body= JSON.stringify(datesFilter);
      return this.http.get<BOToothStateDetail[][]>(this.myAppUrl + this.myApiUrl + 'getStateDetailsByChAgroupedByToothId/' + clinicHistoryId);
    }

    deleteStateDetail(stateDetailId:number):Observable<number>{
        return this.http.delete<number>(this.myAppUrl + this.myApiUrl + 'delete/' + stateDetailId);
    }

      //#endregion First

//#region Single
  createOrUpdateToothStateDetailSingle(disease:BOToothStateDetail):Observable<BOToothStateDetail>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(disease);
      return this.http.post<BOToothStateDetail>(this.myAppUrl + this.myApiUrl + 'createOrUpdateToothStateDetailSingle',body,httpOptions);
  }

  deleteToothStateDetailSingle(id:number):Observable<BOToothStateDetail>
  {
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOToothStateDetail>(this.myAppUrl + this.myApiUrl + 'deleteToothStateDetailSingle/' + id,null,httpOptions);
  }


//#endregion Single


  }
